export default __webpack_public_path__ + "static/media/CSSCircularBackground-light-sepia-350px.jpg.02e0ebd6.webp";